import { cn } from '@/lib/utils'
import type { FilterOption } from './types'

/**
 * Um grupo de opções mutuamente exclusivas, no lugar de um select: com três ou quatro
 * opções curtas, ver todas de uma vez é mais rápido do que abrir um dropdown para
 * descobrir o que existe.
 *
 * Veio de students/Index.tsx, onde nasceu local; virou compartilhado quando a tela de
 * assinaturas passou a usar o mesmo dialog de filtros.
 */
export function SegmentedControl({
  value,
  options,
  onChange,
}: {
  value: string
  options: readonly FilterOption[]
  onChange: (value: string) => void
}) {
  return (
    <div
      role="radiogroup"
      className="inline-flex flex-wrap gap-1 rounded-lg bg-muted p-1"
    >
      {options.map((option) => {
        const selected = (value || 'all') === option.value
        return (
          <button
            key={option.value}
            type="button"
            role="radio"
            aria-checked={selected}
            onClick={() => onChange(option.value)}
            className={cn(
              'rounded-md px-3 py-1.5 text-sm transition-colors',
              selected
                ? 'bg-background text-foreground font-medium shadow-sm'
                : 'text-muted-foreground hover:text-foreground',
            )}
          >
            {option.label}
          </button>
        )
      })}
    </div>
  )
}
